<template>	
	<div v-if="loading" v-loading="true" style="position: absolute; width: 32px; height: 32px; padding: 20px; margin: 8px;"></div>
	<transition v-else name="open-ticket" transition-mode="out-in">
		<TicketDetails :ticket="ticket" layout="vertical" :description-width="24" :comments-width="24"/>
	</transition>
</template>

<script>
	
	import TicketDetails from "@/components/Projects/Project/TicketDetails";
	
	export default {
		
		components: { TicketDetails },
		
		mounted() {
			this.axios.get(`tickets/${this.$route.params.ticketId}`).then((r) => {
				this.loading = false;
				if (r.data.length) {
					this.ticket = r.data[0];
				}
			});
		},
		
		data() {
			return {
				loading: true,
				ticket: {},
			}
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/TicketItemView.vue